export default function IconNotification({ color = '#1E3A95', width = 48, height = 48, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='48' height='48' rx='16' fill={color} fillOpacity='0.1' />
      <path
        d='M14.6667 33.3333H21.6667C21.6667 33.9522 21.9125 34.5457 22.3501 34.9832C22.7877 35.4208 23.3812 35.6667 24 35.6667C24.6188 35.6667 25.2123 35.4208 25.6499 34.9832C26.0875 34.5457 26.3333 33.9522 26.3333 33.3333H33.3333C33.6428 33.3333 33.9395 33.2104 34.1583 32.9916C34.3771 32.7728 34.5 32.4761 34.5 32.1667C34.5 31.8572 34.3771 31.5605 34.1583 31.3417C33.9395 31.1229 33.6428 31 33.3333 31V22.8333C33.3333 20.358 32.35 17.984 30.5997 16.2337C28.8493 14.4833 26.4754 13.5 24 13.5C21.5246 13.5 19.1507 14.4833 17.4003 16.2337C15.65 17.984 14.6667 20.358 14.6667 22.8333V31C14.3572 31 14.0605 31.1229 13.8417 31.3417C13.6229 31.5605 13.5 31.8572 13.5 32.1667C13.5 32.4761 13.6229 32.7728 13.8417 32.9916C14.0605 33.2104 14.3572 33.3333 14.6667 33.3333ZM17 22.8333C17 20.9768 17.7375 19.1963 19.0503 17.8836C20.363 16.5708 22.1435 15.8333 24 15.8333C25.8565 15.8333 27.637 16.5708 28.9497 17.8836C30.2625 19.1963 31 20.9768 31 22.8333V31H17V22.8333Z'
        fill={color}
      />
    </svg>
  );
}
